/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_SelectInputs */

const cs_settings_teams_select = /** @type {(inputs: Settings_Teams_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte tým`)
};

const en_settings_teams_select = /** @type {(inputs: Settings_Teams_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a team`)
};

/**
* | output |
* | --- |
* | "Select a team" |
*
* @param {Settings_Teams_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_select = /** @type {((inputs?: Settings_Teams_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_select(inputs)
	return cs_settings_teams_select(inputs)
});